/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	lineRefresh: {
		height: '1px',
		width: '100%',
		backgroundColor: token('color.background.accent.gray.subtler'),
	},
});

export const SeparatorLineRefresh: () => JSX.Element = () => <Box xcss={styles.lineRefresh} />;
